import { C21ContentFeedForHealthNewsProps } from './C21ContentFeedForHealthNews.types';
import { ContentFeedForHealthNewsProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';

export function GetContentFeedForHealthNewsModel(
  props?: C21ContentFeedForHealthNewsProps
): ContentFeedForHealthNewsProps {
  type t = ContentFeedForHealthNewsProps;

  const { params, fields } = props || {};
  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  const model: ContentFeedForHealthNewsProps = {
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    cards: props?.cards ?? [],
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'center'),
    shouldHideImagesOnMobile: getCheckbox(params?.HideImagesOnMobile),
    enableCarouselOnMobile: getCheckbox(params?.EnableCarouselOnMobile),
    shouldHideSupportCopyOnCards: getCheckbox(params?.HideSupportCopyOnCards),
    slideTimingInSeconds: parseInt(params?.SlideTimingInSeconds ?? '6'),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: renderLink(fields?.CTA),
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };

  return model;
}
